import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'

import type { FC } from 'react'

interface CardPenilaianKinerjaStepProps {
  title: string
  description: string
  withIcon?: boolean
}

const CardPenilaianKinerjaStep: FC<CardPenilaianKinerjaStepProps> = ({
  title,
  description,
  withIcon = false,
}) => {
  return (
    <>
      {withIcon && (
        <div className="flex-none">
          <Icon color="informational" className="!cursor-default">
            arrow_circle_right
          </Icon>
        </div>
      )}

      <div className="flex flex-row gap-3">
        <div className="max-w-full space-y-0.5">
          <Text variant="action" className="!text-blue-60">
            {title}
          </Text>
          <Text variant="body-sm">{description}</Text>
        </div>
      </div>
    </>
  )
}
export default CardPenilaianKinerjaStep
